import { SET_FILTER, CLEAR_FILTER } from "../actions/FilterActions";

const initialState = {};

export const filters = (state = initialState, action) => {
  switch (action.type) {
    case SET_FILTER:
      return { ...state, [action.key]: action.value };
    case CLEAR_FILTER: {
      const next = { ...state };
      delete next[action.key];
      return next;
    }
    default:
      return state;
  }
};
